import DateUtils from './date-utils'

class ArrayUtils {
    static arrayToHashMap(arr) {
      return arr.reduce((map, obj) => {
          map[obj.Code] = obj
          return map
        }, {})
    }

    static async flattenOrdersCollection({ Main, Acct, Item}) {
        return new Promise((resolve, _) => {
            const collection = []
            const ItemMap = ArrayUtils.arrayToHashMap(Item)
            const noDups = {}

            Acct.forEach((account) => {
                const invoices = Main.filter(item => item.AcctNo === account.AcctNo)
                invoices.forEach((invoice) => {
                    const details = invoice.Det
                    details.forEach((detail) => {
                        const itemDetail = ItemMap[detail.Item]
                        const { Acct, AcctNo, Aff, Prem } = account
                        let { ShpDate, ExpDate, ArrDate, OrdDate, LstInvDate } = invoice
                        const { OrdNo, Typ, Hold, Cmt, Coop, Ter, Rep, ShpTo, Inv, LstInvNo } = invoice
                        const { Item, Qty, Pri, Tot, ItmCmt, AvailCmt, Cost } = detail
                        const { Code, Desc, Allo } = itemDetail || {}
                        let { BoEta } = detail

                        OrdDate = DateUtils.convertStringToDate(OrdDate)
                        ShpDate = DateUtils.convertStringToDate(ShpDate)
                        ExpDate = DateUtils.convertStringToDate(ExpDate)
                        ArrDate = DateUtils.convertStringToDate(ArrDate)
                        LstInvDate = DateUtils.convertStringToDate(LstInvDate)
                        BoEta = DateUtils.convertStringToDate(BoEta)

                        const flattenData = {
                            Acct, AcctNo, Aff, Prem,
                            OrdNo, OrdDate, ShpDate, ExpDate, ArrDate, LstInvDate, LstInvNo, Typ, Hold, Cmt, Coop, Ter, Rep, ShpTo, Inv,
                            Item, Desc, Qty, Pri, Tot, ItmCmt, AvailCmt, Cost,
                            Code, BoEta, Allo
                        }

                        const key = getKey(flattenData)

                        if (!noDups[key]) {
                            collection.push(flattenData)
                            noDups[key] = true
                        }
                    })
                })

            })
            resolve(collection)
        })
    }

    static async flattenInvoiceCollection({ Main, Acct, Item }) {
        return new Promise((resolve, _) => {
            const collection = []
            const ItemMap = ArrayUtils.arrayToHashMap(Item)
            const noDups = {}

            Acct.forEach((account) => {
                const invoices = Main.filter(item => item.AcctNo === account.AcctNo)
                invoices.forEach((invoice) => {
                    const details = invoice.Det
                    details.forEach((detail) => {
                        const itemDetail = ItemMap[detail.Item]
                        const { AcctNo, Acct, AcctR, Prem, Ter, Aff } = account
                        const { InvNo, Typ, Cmt, Coop, InvR } = invoice
                        let { Date } = invoice
                        const { Item, Qty, Pri, Tot } = detail
                        const { ITyp, Vari, Desc, Ctry, Reg, App, Mv, Foc, FocBm, Bio, Org, RstAllo, Core } = itemDetail || {} // Item code not found
                        Date = DateUtils.convertStringToDate(Date)
                        const flattenData = {
                            AcctNo, Acct, AcctR, Prem, Ter, Aff,
                            InvNo, Date, Typ, Cmt, Coop, InvR,
                            Item, Desc, Qty, Pri, Tot,
                            ITyp, Vari, Ctry, Reg, App, Mv, Foc, FocBm, Bio, Org, RstAllo, Core
                        }

                        const key = getKey(flattenData)

                        if (!noDups[key]) {
                            collection.push(flattenData)
                            noDups[key] = true
                        }

                    })
                })
            })

            resolve(collection)
        })
    }

    static async flattenSamplesCollection({ Main, Acct, Item }) {
      if (!Acct) {
        return new Promise((resolve, _) => {
          const collection = []
          const ItemMap = ArrayUtils.arrayToHashMap(Item)
          const noDups = {}

          Main.forEach(currentMain => {
            const detailsOfCurrentMain = currentMain.Det
            detailsOfCurrentMain.forEach(det => {
              const itemByDetailCode = ItemMap[det.Code]

              let { Date } = currentMain
              const { PoNo, ShpTo } = currentMain
              const { Code, Qty, ItemComment } = det
              const { Ctry, Reg, App, Brnd, Desc, Vend, Mv, Foc, BmFoc } = itemByDetailCode

              Date = DateUtils.convertStringToDate(Date)

              const flattenData = {
                Date, PoNo, ShpTo,
                Code, Qty, ItemComment,
                Ctry, Reg, App, Brnd, Desc, Vend, Mv, Foc, BmFoc
              }

              const key = getKey(flattenData)

              if (!noDups[key]) {
                collection.push(flattenData)
                noDups[key] = true
              }

            })
          })

          resolve(collection)
        })
      }


      return new Promise((resolve, _) => {
        const collection = []
        const ItemMap = ArrayUtils.arrayToHashMap(Item)
        const noDups = {}

        Acct.forEach((account) => {
          const invoices = Main.filter(item => item.RepNo === account.RepNo)
          invoices.forEach((invoice) => {
            const details = invoice.Det
            details.forEach((detail) => {
              const itemDetail = ItemMap[detail.Code]
              const { RepNo, Ter, RepName, } = account
              const { PoNo, ShpTo } = invoice
              let { Date } = invoice
              const { Code, Qty, Cost, ItemComment } = detail
              const { ItemCode, Ctry, Reg, App, Brnd, Desc, Vend, Mv, Foc } = itemDetail || {} // Item code not found
              Date = DateUtils.convertStringToDate(Date)
              const flattenData = {
                RepNo, Ter, RepName,
                PoNo, ShpTo, Date,
                Code, Qty, Cost, ItemComment,
                ItemCode, Ctry, Reg, App, Brnd, Desc, Vend, Mv, Foc
              }

              const key = getKey(flattenData)

              if (!noDups[key]) {
                collection.push(flattenData)
                noDups[key] = true
              }

            })
          })
        })

        resolve(collection)
      })
    }

    static async noFlatteningCollection({ Main, Acct, Item }) {
        return new Promise((resolve, _) => {
            resolve(Main)
        })
    }
}

const getKey = (data) => {
    let key = ''

    Object.keys(data).forEach( currentKey => {
        key += data[currentKey]
    })

    return key
}

export const deleteKeyFromObjectInArray = (array, key) => {
  return array.map(object => {
    const tempObject = {...object}
    delete tempObject[key]
    return tempObject
  })
}

export default ArrayUtils
